import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0b31c68b&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.scss?vue&type=style&index=0&id=0b31c68b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b31c68b",
  null
  
)

export default component.exports